module.exports = __webpack_public_path__ + "fonts/Inter-800-cyrillic-ext71.df55b7e.woff2";